import { render, staticRenderFns } from "./SingleReceivable.vue?vue&type=template&id=0dbeee04"
import script from "./SingleReceivable.vue?vue&type=script&lang=js"
export * from "./SingleReceivable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports